import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Listener represents event listener.

// EventBus is a simple non cohesive event bus contract.

class EventBusImpl {
  constructor() {
    _defineProperty(this, "listeners", {});
  }
  subscribe(name, l) {
    if (!this.listeners[name]) {
      this.listeners[name] = [];
    }
    this.listeners[name].push(l);
  }
  unsubscribe(name, l) {
    if (!this.listeners[name]) {
      return;
    }
    this.listeners[name] = this.listeners[name].filter(item => item !== l);
  }
  publish(name, d) {
    var _this$listeners$name;
    const listnrs = (_this$listeners$name = this.listeners[name]) !== null && _this$listeners$name !== void 0 ? _this$listeners$name : [];

    // TODO should run as promises to introduce async behavior?
    listnrs.forEach(l => l(name, d));
  }
}
const eventBus = new EventBusImpl();

// export singleton.
export default eventBus;
//# sourceMappingURL=index.js.map